import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import NoProfessionalsList from '../components/NoProfessionalsList'

export default function ManageNoProfessionals() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">No. Engineering Professionals</h1>
        <Link to="/new-noprofessional"><button className="memberAddButton">Add New</button></Link>
      </div>
        <NoProfessionalsList />
    </div>
  )
}
